import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

/**
 * libs
 */
import { TranslatePipe } from '@ngx-translate/core';

/**
 * interfaces
 */
import { ITableTreeRowNode } from '../../interfaces';

/**
 * components
 */
import { TreeTableComponent } from '../tree-table/tree-table.component';

/**
 * The expand/collapse button of one `app-tree-table` row, placed in the
 * row's hierarchy cell. It owns no state: it reads the row node and asks the
 * owning tree table to toggle it. On a leaf it keeps its space but is
 * invisible, so it is neither clickable, focusable nor announced.
 */
@Component({
    selector: 'app-table-tree-toggler',
    templateUrl: './table-tree-toggler.component.html',
    styleUrl: './table-tree-toggler.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class TableTreeTogglerComponent {

    /** Resolved from the `<app-tree-table>` the body template is declared in. */
    private readonly _treeTable = inject(TreeTableComponent);

    public readonly rowNode = input.required<ITableTreeRowNode<unknown>>();

    /** The row's name, spoken in the button's accessible label ("Expand {{name}}"). */
    public readonly rowLabel = input.required<string>();

    public onToggle(): void {
        this._treeTable.toggleRow(this.rowNode());
    }
}
